import request from "@/network/request";

// 查询微信公众号处方支付信息
export function requestGoodsPrescription(data) {
  return request({
    url: `/sclm/apply/app/scan/generateGoods`,
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能
    return res;
  });
}
// 查询微信公众号处方支付信息
export function requestPrescription(data) {
  return request({
    url: `/sclm/apply/app/scan/generate`,
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能

    return res;
  });
}
// 公共版内网微信处方支付信息
export function wechatRequestPrescription(data) {
  return request({
    url: `/sclm/apply/app/scanWeixin/generate`,
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能

    return res;
  });
}

// 查询微信公众号处方支付信息
export function requestPrescriptionNoWifi(data) {
  return request({
    url: `/sclm/apply/app/scan/generateNoWifi`,
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能

    return res;
  });
}

// 查询微信公众号处方支付信息
export function requestInvoicePrescription(data) {
  return request({
    url: `/sclm/apply/app/scan/advice`,
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能

    return res;
  });
}
// 暨南大学支付信息
export function jndxRequestInvoicePrescription(data) {
  return request({
    url: `/sclm/apply/app/scanJinan/mealsAdvice`,
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能

    return res;
  });
}
// 获取用法用量数据
export function requestPrescriptionUsage(data) {
  return request({
    url: "/api/scan/scanAdviceDetail",
    method: "post",
    data,
  });
}

// 获取微信登录数据
export function requestGetJsticket(data) {
  return request({
    url: "/hospitalordering/applet/user/user/jsticket",
    method: "post",
    data,
  });
}

//支付信息提交
export function generatePatientSubmit(data) {
  return request({
    url: "/sclm/apply/app/scans/generatePatientInfo",
    method: "post",
    data,
  });
}

//手动输入金额
export function generateMoneySubmit(data) {
  return request({
    url: "/sclm/apply/app/scan/generateMoney",
    method: "post",
    data,
  });
}
// 暨南大学支付
export function adviceSave(data) {
  return request({
    url: "/sclm/apply/app/scan/adviceSave",
    method: "post",
    data,
  });
}

// 暨南大学预交费查询信息
export function advancePaymentInfo(data) {
  return request({
    url: "/sclm/apply/app/scanJinan/queryPatientInfo",
    method: "post",
    data,
  });
}
// 暨南大学预交费支付
export function createAdvancePaymentOrder(data) {
  return request({
    url: "/sclm/apply/app/scanJinan/createAdvancePaymentOrder",
    method: "post",
    data,
  });
}
// 宝丰预交费查询信息
export function bfAdvancePaymentInfo(data) {
  return request({
    url: "/sclm/apply/app/scanBaoFeng/queryPatientInfo",
    method: "post",
    data,
  });
}
// 宝丰预交费支付
export function bfCreateAdvancePaymentOrder(data) {
  return request({
    url: "/sclm/apply/app/scanBaoFeng/createAdvancePaymentOrder",
    method: "post",
    data,
  });
}
// 山西省人民医院预交费查询信息
export function advanceSxsrmyyPaymentInfo(data) {
  return request({
    url: "/sclm/apply/app/scanSxsrm/queryPatientInfo",
    method: "post",
    data,
  });
}
// 山西省人民医院预交费支付
export function createSxsrmyyAdvancePaymentOrder(data) {
  return request({
    url: "/sclm/apply/app/scanSxsrm/createAdvancePaymentOrder",
    method: "post",
    data,
  });
}
// 省人民获取信息
export function srmquestInvoicePrescription(data) {
  return request({
    url: "/sclm/apply/app/scanSxsrm/adviceInfoNoWx",
    method: "post",
    data,
  }).then((res) => {
    // 这里插播一些操作，异步执行，不影响当前任何功能

    return res;
  });
}

// 获取微信支付信息
export function queryWxauth(data) {
  return request({
    url: "/sclm/apply/app/scanSxsrm/wxAuth",
    method: "post",
    data,
  });
}

// 微信认证
export function wxAuth(data) {
  return request({
    url: "/sclm/apply/app/scanSxsrm/wxAuth",
    method: "post",
    data,
  });
}

// 微信支付
export function weixinpay(data) {
  return request({
    url: "/sclm/apply/app/scanSxsrm/wechatPayPassword",
    method: "post",
    data,
  });
}
// 签名保存
export function esignSave(data) {
  return request({
    url: "/sclm/apply/app/scan/adviceSaveZQTYS",
    method: "post",
    data,
  });
}
// 复购
export function wechatUserBind(data) {
  return request({
    url: "https://shop.sxmfyy.com/api/open/wechat/user-bind",
    method: "post",
    data,
  });
}
